import { render, staticRenderFns } from "./ListItemStickerComponent.vue?vue&type=template&id=2a997add&"
import script from "./ListItemStickerComponent.vue?vue&type=script&lang=js&"
export * from "./ListItemStickerComponent.vue?vue&type=script&lang=js&"
import style0 from "./ListItemStickerComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports